import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BillModel } from '@data-layer/models/payments';

@Component({
  selector: 'app-month-bill-failed',
  templateUrl: './month-bill-failed.component.html',
  styleUrls: ['./month-bill-failed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthBillFailedComponent {
  @Input() public textTranslationKey: string = 'ERROR_CHANGE_YOUR_PAYMENT_METHOD';
  @Input() public organizationOrCompanyFailedBill: BillModel;
  @Output() public payNow: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}
}
